import React from 'react';

import { _I_ } from 'components/translate';
import { LogStream } from 'generics/common';
import { classMixer } from 'generics/utils';

LogStream.enable("VIEWACHIEVEMENTUNLOCKPROGRESS");

export class ViewAchievementUnlockProgress extends React.Component {

  renderProgress(k, unlocked, compare) {
    const { total, comparenick } = this.props;
    const progress = (unlocked / total) * 100;
    const progressStyle = { "width": progress + '%' };
    const unlockClass = compare ? "view-item-progress-compare" : "";
    const nick = compare ? comparenick : _I_("ViewUnlockProgress.myUnlock");

    return (
      <div className={classMixer("view-item-progress", unlockClass)} key={k}>
        <div className="nick">{nick}</div>
        <div>{unlocked} {_I_("ViewUnlockProgress.of")} {total} ({parseInt(progress)}%) {_I_("ViewUnlockProgress.achievCompleted")}</div>
        <div className="progress-bar">
          <div className="progress-bar-state" style={progressStyle}></div>
        </div>
      </div>
    )
  }

  render() {
    const { total, unlocked, unlockedCompare, usernick, comparenick, limited } = this.props;

    let progressList = [];

    if (total && !limited) {
      if (comparenick && comparenick != usernick) {
        progressList.push(
          this.renderProgress("compare", unlocked, true),
          this.renderProgress("our", unlockedCompare, false)
        );
      }
      else {
        progressList.push(
          this.renderProgress("our", unlocked, false)
        );
      }
    }


    return (
      <div className="ViewItemProgressBlock">
        {progressList}
      </div>
    );
  }
}